import React from "react";
import { Grid } from "@mui/material";
import ReviewAndCorrectSortFilter from "./ReviewAndCorrectSortFilter";
import BuyerInventoryRecords from './BuyerInventoryRecords';
import { withSnackbar } from "../../hocs/withSnackbar";
import Pagination from "../../deprecatedUikit/Pagination/Pagination";
import {BuyerInventoryFilterContainer} from "../../../views/inventory-correction/BuyerInventoryCorrections/styles";

const ReviewAndCorrectTab = (props) => {
    const {
        handleDeleteCorrection,
        handleSubmitCorrection,
        loading,
        inventoryRecords,
        setQuery,
        initialQuery,
        totalRecords,
        page,
        setPage,
        size,
        setSize,
        setStartDate,
        setEndDate,
        setSort,
    } = props

    const handlePageChange = (_, page) => {
        setPage(page)
    };

    const shouldResetPage = (requestedPage, rowsPerPage, totalBookings) => {
        const newPageCount = Math.ceil(totalBookings / rowsPerPage);
        return requestedPage > 0 ? newPageCount < requestedPage + 1 : false;
    };

    const handleRowsPerPageChange = ({target}) => {
        if (shouldResetPage(page, target.value, inventoryRecords.length)) {
        setPage(0);
        }
        setSize(target.value);
    }

    return <Grid container>
        <BuyerInventoryFilterContainer item container p={2} mb={4}>
            <ReviewAndCorrectSortFilter
                setQuery={setQuery}
                initialQuery={initialQuery}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setSort={setSort}
            />
        </BuyerInventoryFilterContainer>
        <BuyerInventoryRecords
            loading={loading}
            inventoryRecords={inventoryRecords}
            handleDeleteCorrection={handleDeleteCorrection}
            handleSubmitCorrection={handleSubmitCorrection}
        />
        <Pagination
            count={totalRecords}
            rowsPerPage={size}
            page={page}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            variant="tablePagination"
        />
    </Grid>
};

export default withSnackbar(ReviewAndCorrectTab);
